const LOGO_ON_LIGHT = '/branding/movofleet-logo-nero.svg';
const LOGO_ON_DARK = '/branding/movofleet-logo-bianco.svg';

const variantClass = {
  marketing: 'h-10 w-auto max-w-[min(220px,52vw)]',
  form: 'h-9 w-auto max-w-[200px]',
  /** Le schermate di accesso */
  auth: 'h-14 w-14',
  /** Solo simbolo in sidebar collassata (contenitore esterno ~44px) */
  sidebarMark: 'h-7 w-7 object-contain object-center max-w-none',
};

type MovoFleetLogoProps = {
  variant: keyof typeof variantClass;
  className?: string;
  alt?: string;
};

/**
 * Logo Movo Fleet (SVG ufficiali in `public/branding/`): nero in chiaro, bianco
 * sotto `.dark`. L'immagine nascosta da `display: none` non arriva agli screen reader.
 */
export default function MovoFleetLogo({
  variant,
  className = '',
  alt = 'Movo Fleet',
}: MovoFleetLogoProps) {
  const baseClass =
    `object-contain ${variant === 'sidebarMark' ? 'object-center' : 'object-left'} ${variantClass[variant]} ${className}`.trim();
  const imgProps = { alt, loading: 'lazy', decoding: 'async' } as const;

  return (
    <>
      <img src={LOGO_ON_LIGHT} className={`${baseClass} dark:hidden`} {...imgProps} />
      <img src={LOGO_ON_DARK} className={`${baseClass} hidden dark:inline`} {...imgProps} />
    </>
  );
}
